webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
__webpack_require__("wPPq");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0ox+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_my_account_common__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-information-form',
  inject: ['$validator'],
  props: {
    validationScope: {
      type: String,
      default: 'userInformation'
    },
    userInformation: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          phone: '',
          address: {
            city: '',
            state: '',
            street: '',
            street2: '',
            zipCode: ''
          }
        };
      }
    }
  },
  data: function data() {
    return {
      states: __WEBPACK_IMPORTED_MODULE_0_my_account_common__["STATE_LIST"]
    };
  },

  methods: {
    SetAddressInput: function SetAddressInput(field, value) {
      this.userInformation.address[field] = value;
      this.$emit('input', this.userInformation);
    },
    SetUserInfoInput: function SetUserInfoInput(field, value) {
      this.userInformation[field] = value;
      this.$emit('input', this.userInformation);
    },
    SetZipcodeInput: function SetZipcodeInput(value) {
      this.userInformation.address.zipCode = value.replace(/\D/g, '');
      this.$emit('input', this.userInformation);
    }
  }
});

/***/ }),

/***/ "14Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_custom_validators__ = __webpack_require__("gxZo");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'member-validaton-form',
  inject: ['$validator'],
  props: {
    reEnableSubmitButton: false,
    memberLoginUrl: '',
    validationScope: {
      type: String,
      default: 'memberData'
    }
  },
  data: function data() {
    return {
      isFormSubmitted: false,
      memberValidationData: {
        memberIdentifier: '',
        birthDate: ''
      }
    };
  },
  created: function created() {
    this.$validator.extend('birthDateFormatValidator', __WEBPACK_IMPORTED_MODULE_1__services_custom_validators__["a" /* birthDateFormatValidator */]);
  },

  methods: {
    validateMember: function validateMember() {
      this.isFormSubmitted = true;
      this.memberValidationData.birthDate = this.memberBirthdate;
      this.$emit('submitData', this.memberValidationData);
    },
    openModal: function openModal() {
      this.$emit('openModal');
    },
    goToLogin: function goToLogin() {
      window.open(this.memberLoginUrl, '_self');
    }
  },
  computed: {
    memberBirthdate: function memberBirthdate() {
      var date = this.memberValidationData.birthDate;
      if (date.length === 8) {
        return date.substring(0, 2) + '/' + date.substring(2, 4) + '/' + date.substring(4, 8);
      } else {
        return date;
      }
    },
    isFormValidated: function isFormValidated() {
      var _this = this;

      if (this.fields.$memberData) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields.$memberData).every(function (key) {
          return _this.fields.$memberData[key].valid;
        });
      } else {
        return false;
      }
    }
  },
  watch: {
    reEnableSubmitButton: function reEnableSubmitButton(value) {
      if (value) {
        this.isFormSubmitted = !value;
      }
    }
  }
});

/***/ }),

/***/ "1xYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__ = __webpack_require__("wcAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fbe240_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__ = __webpack_require__("wpyf");
function injectStyle (ssrContext) {
  __webpack_require__("AnSi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fbe240_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "26Hx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberValidation_vue__ = __webpack_require__("9ZMU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d8daae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberValidation_vue__ = __webpack_require__("vTfw");
function injectStyle (ssrContext) {
  __webpack_require__("Yw9J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberValidation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d8daae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberValidation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4sUD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.svg";

/***/ }),

/***/ "5SNe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-eot.eot";

/***/ }),

/***/ "85ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    label: {
      default: 'Loading...'
    },
    show: {
      default: false
    },
    overlay: {
      default: true
    },
    // central event bus
    eventBus: {
      default: null
    },
    eventShow: {
      default: 'show-full-loading'
    },
    eventHide: {
      default: 'hide-full-loading'
    }
  },
  data: function data() {
    return {
      showing: false
    };
  },

  watch: {
    show: function show(val) {
      this.showing = val;
    }
  },
  methods: {
    showMe: function showMe() {
      this.showing = true;
    },
    hideMe: function hideMe() {
      this.showing = false;
    },

    // Register eventBus methods.
    registerBusMethods: function registerBusMethods() {
      this.eventBus.$on(this.eventShow, this.showMe);
      this.eventBus.$on(this.eventHide, this.hideMe);
    }
  },
  mounted: function mounted() {
    // If event bus, register methods.
    if (this.eventBus) {
      this.registerBusMethods();
    }
  }
});

/***/ }),

/***/ "9ZMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MemberValidationForm__ = __webpack_require__("V/CG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ServiceContainer__ = __webpack_require__("tpCU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MemberNumberModal__ = __webpack_require__("g1H4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_configuration_PropertiesConfiguration__ = __webpack_require__("d45q");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'member-validation',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__["a" /* default */],
    MemberValidationForm: __WEBPACK_IMPORTED_MODULE_2__components_MemberValidationForm__["a" /* default */],
    MemberNumberModal: __WEBPACK_IMPORTED_MODULE_5__components_MemberNumberModal__["a" /* default */]
  },
  data: function data() {
    return {
      isModalOpen: false,
      showSpinner: false,
      memberLoginUrl: __WEBPACK_IMPORTED_MODULE_6__services_configuration_PropertiesConfiguration__["a" /* default */].memberLoginUrl,
      reEnableSubmitButton: false,
      memberValidationData: {
        memberIdentifier: '',
        birthDate: ''
      },
      memberValidationError: ''
    };
  },
  mounted: function mounted() {
    this.showSpinner = true;
    this.showSpinner = false;
  },

  methods: {
    validateMember: function validateMember(data) {
      var _this = this;

      this.memberValidationData = data;
      this.reEnableSubmitButton = false;
      __WEBPACK_IMPORTED_MODULE_3__services_ServiceContainer__["b" /* memberValidationService */].validateMember({
        params: this.memberValidationData
      }).then(function (success) {
        // Setting user input data in store
        _this.$store.commit('setMemberValidationData', _this.memberValidationData);
        // Setting member data in store
        _this.$store.commit('setMemberData', _this.buildDataObject(success.data));
        // Setting security questions in store
        _this.$store.commit('setSecurityQuestionCatalog', success.data.securityQuestions);
        // Setting member validation status, so a user cannot be in step 2 without this
        _this.$store.commit('setMemberValidationStatus', true);
        // Setting user email to store
        _this.$store.commit('setEmailAddress', success.data.email);

        // redirecting user to step 2
        _this.$router.push({ name: 'CreateProfile' });
      }).catch(function (error) {
        _this.reEnableSubmitButton = true;
        if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
          _this.memberValidationError = error.response.data.errorMessage;
        } else {
          _this.memberValidationError = 'There was an unexpected error when trying to validate the member';
        }
      });
    },
    buildDataObject: function buildDataObject(response) {
      var userData = {
        firstName: response.firstName,
        lastName: response.lastName,
        phone: response.phone,
        address: response.address,
        memberNumber: response.memberNumber
      };

      return userData;
    },
    openModal: function openModal() {
      this.isModalOpen = true;
    },
    closeModal: function closeModal() {
      this.isModalOpen = false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getIsMemberValidated', 'getMemberData']))
});

/***/ }),

/***/ "AUbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateProfileService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__ = __webpack_require__("d45q");




var CreateProfileService = function () {
  function CreateProfileService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CreateProfileService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CreateProfileService, [{
    key: 'validateUsername',
    value: function validateUsername(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].validateUsernameUrl, config);
    }
  }, {
    key: 'registerMember',
    value: function registerMember(config) {
      return this.axios.post(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].registerMemberUrl, config);
    }
  }, {
    key: 'getMyProfileUrl',
    value: function getMyProfileUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].myProfileUrl;
    }
  }]);

  return CreateProfileService;
}();

/***/ }),

/***/ "AnSi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BOYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecurityQuestionForm_vue__ = __webpack_require__("ZLlC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03202b3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecurityQuestionForm_vue__ = __webpack_require__("zreh");
function injectStyle (ssrContext) {
  __webpack_require__("bfMu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecurityQuestionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03202b3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecurityQuestionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Chc6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sign_in.jpg";

/***/ }),

/***/ "E66g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_configuration_PropertiesConfiguration__ = __webpack_require__("d45q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'already-registered-modal',
  mounted: function mounted() {
    document.addEventListener('keyup', this.listener);
    this.contactUsURL = __WEBPACK_IMPORTED_MODULE_0__services_configuration_PropertiesConfiguration__["a" /* default */].contactUsUrl;
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.listener);
  },
  data: function data() {
    var _this = this;

    return {
      fitPerksURL: 'https://www.24hourfitness.com/fitperks/',
      contactUsURL: '',
      listener: function listener(evt) {
        if (evt.keyCode === 27) {
          _this.$emit('closeModal');
        }
      }
    };
  },

  methods: {
    redirectToContactUs: function redirectToContactUs() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__services_configuration_PropertiesConfiguration__["a" /* default */].contactUsUrl;
    }
  }
});

/***/ }),

/***/ "FmzD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJ/R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IAAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24",attrs:{"id":"create-profile-container"}},[_c('loading',{attrs:{"show":_vm.showSpinner,"label":"Loading...","overlay":"true"}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"container profile-container"},[_vm._m(1,false,false),_vm._v(" "),_c('user-information-form',{attrs:{"userInformation":_vm.memberData},on:{"input":function (nValue) { return _vm.setMemberData(nValue); }}})],1),_vm._v(" "),_c('div',{staticClass:"container profile-container"},[_vm._m(2,false,false),_vm._v(" "),_c('login-credentials-form',{attrs:{"value":_vm.userCredentials},on:{"input":function (nValue) { return _vm.setUserCredentials(nValue); }}})],1),_vm._v(" "),_c('div',{staticClass:"container profile-container"},[_vm._m(3,false,false),_vm._v(" "),_c('security-question-form',{attrs:{"securityQuestionCatalog":_vm.securityQuestionCatalog,"value":_vm.selectedSecurityQuestion},on:{"input":function (nValue) { return _vm.setSelectedQuestion(nValue); }}})],1),_vm._v(" "),_c('div',{staticClass:"container profile-container",attrs:{"id":"terms-of-use"}},[_c('terms-of-use',{attrs:{"value":_vm.termsOfUse,"areAllFormsValid":_vm.areAllFormsValid,"reEnableSubmitButton":_vm.reEnableSubmitButton},on:{"submitForm":function($event){_vm.submitForm()},"cancelRegistration":function($event){_vm.cancelRegistration()},"input":function (nValue) { return _vm.setTermsOfUseData(nValue); }}})],1),_vm._v(" "),(_vm.isModalOpen)?_c('already-registered-modal',{on:{"closeModal":_vm.closeModal}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container profile-container"},[_c('div',{staticClass:"row profile-section"},[_c('section',{staticClass:"col-sm-12 profile-desc-header"},[_c('h3',{staticClass:"title-24"},[_vm._v("2. Create Your Login")]),_vm._v(" "),_c('section',{staticClass:"card-24"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title-24"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Verify your information")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title-24"},[_c('i',{staticClass:"fa fa-address-card-o"}),_vm._v(" Create your login credentials")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title-24"},[_c('i',{staticClass:"fa fa-question-circle-o"}),_vm._v(" Set up your security question")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IT7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-form",attrs:{"id":"login-credentials-form"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uName),expression:"uName"},{name:"validate",rawName:"v-validate",value:('required|min:6|max:60|hasSpecialCharacterValidator|verify-username'),expression:"'required|min:6|max:60|hasSpecialCharacterValidator|verify-username'"}],staticClass:"form-control",attrs:{"type":"text","id":"username","placeholder":"Username","name":"username","data-vv-scope":_vm.validationScope,"data-vv-delay":"1000"},domProps:{"value":(_vm.uName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.uName=$event.target.value},function (event) { return _vm.setValue('username', event.target.value); }]}}),_vm._v(" "),_c('label',{attrs:{"for":"username"}},[_vm._v("Username")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.username')),expression:"errors.has(validationScope + '.username')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.username'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"type":"text","id":"email","placeholder":"Email","name":"email","data-vv-scope":_vm.validationScope},domProps:{"value":_vm.value.email},on:{"input":function (event) { return _vm.setValue('email', event.target.value); }}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.email')),expression:"errors.has(validationScope + '.email')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.email'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:14|hasNumberValidator|hasUpperCaseValidator|hasLowerCaseValidator|hasUpperAndLowerLetterValidator'),expression:"'required|min:8|max:14|hasNumberValidator|hasUpperCaseValidator|hasLowerCaseValidator|hasUpperAndLowerLetterValidator'"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","id":"password","maxlength":"14","name":"password","placeholder":"Password","data-vv-scope":_vm.validationScope,"aria-invalid":_vm.errors.has(_vm.validationScope + '.newPassword')},domProps:{"value":_vm.value.password},on:{"input":function (event) { return _vm.setValue('password', event.target.value); }}}),_vm._v(" "),_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('span',{staticClass:"input-group-btn btn btn-view"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.togglePassword(_vm.$refs.password)}}},[_c('i',{staticClass:"fa fa-eye",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.password')),expression:"errors.has(validationScope + '.password')"}],staticClass:"help form-errors"},[_vm._v(_vm._s(_vm.errors.first(_vm.validationScope + '.password')))])]),_vm._v(" "),_c('div',{staticClass:"tooltips"},[_c('ul',{staticClass:"list-unstyled"},[_vm._m(0,false,false),_vm._v(" "),_c('li',{class:{ 'ok-check' : _vm.validateLength(_vm.value.password) }},[_c('i',{staticClass:"fa fa-check-circle-o",attrs:{"aria-hidden":"true"}}),_vm._v(" 8 to 14 characters\n          ")]),_vm._v(" "),_c('li',{class:{ 'ok-check' : _vm.validateHasUpperAndLowerLetter(_vm.value.password) }},[_c('i',{staticClass:"fa fa-check-circle-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Upper and lowercase letters (e.g. Aa)\n          ")]),_vm._v(" "),_c('li',{class:{ 'ok-check' : _vm.validateHasANumber(_vm.value.password) }},[_c('i',{staticClass:"fa fa-check-circle-o",attrs:{"aria-hidden":"true"}}),_vm._v(" At least one number (e.g. 1234)\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:14|confirmed:password'),expression:"'required|min:8|max:14|confirmed:password'"}],ref:"confirmPassword",staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","name":"confirmPassword","maxlength":"14","data-vv-scope":_vm.validationScope,"placeholder":"Confirm New Password","aria-invalid":_vm.errors.has(_vm.validationScope + '.confirmPassword')},domProps:{"value":_vm.value.confirmPassword},on:{"input":function (event) { return _vm.setValue('confirmPassword', event.target.value); }}}),_vm._v(" "),_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('span',{staticClass:"input-group-btn btn btn-view"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.togglePassword(_vm.$refs.confirmPassword)}}},[_c('i',{staticClass:"fa fa-eye",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.confirmPassword')),expression:"errors.has(validationScope + '.confirmPassword')"}],staticClass:"help form-errors"},[_vm._v(_vm._s(_vm.errors.first(_vm.validationScope + '.confirmPassword')))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('h5',{staticClass:"tooltip-title"},[_vm._v("Your password must have")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iage":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","tabindex":"-1"}},[_c('title-container',{attrs:{"title":"My24 Account"}}),_vm._v(" "),_c('registration-header'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KVAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginCredentialsForm_vue__ = __webpack_require__("qTov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611fc12a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginCredentialsForm_vue__ = __webpack_require__("IT7j");
function injectStyle (ssrContext) {
  __webpack_require__("XB6r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginCredentialsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_611fc12a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginCredentialsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4535f57e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Iage");
function injectStyle (ssrContext) {
  __webpack_require__("FmzD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4535f57e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_validation_messages__ = __webpack_require__("lIB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Store__ = __webpack_require__("YZKL");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__webpack_require__("85ql");

var config = {
  locale: 'en',
  dictionary: __WEBPACK_IMPORTED_MODULE_7__assets_validation_messages__["a" /* default */],
  events: 'input'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* default */], config);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_toasted___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_9__Store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */] }
});

/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bc1c490_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("p1eK");
function injectStyle (ssrContext) {
  __webpack_require__("roS0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bc1c490"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bc1c490_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PpSn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RnEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"title-header"},[_vm._v("\n            Where is my Member Number or Check-In Code?\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link pull-right close-modal",on:{"click":function($event){_vm.$emit('closeModal')}}},[_c('i',{staticClass:"fa fa-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('h3',{staticClass:"title-24"},[_vm._v("1. Membership Agreement Number")]),_vm._v(" "),_c('div',{staticClass:"text-24 font-bold"},[_c('p',[_vm._v("\n                  This is located on page 1 of your Membership Agreement document.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('img',{staticClass:"full-img",attrs:{"src":__webpack_require__("u6Tb"),"alt":"Sample Agreement"}})])]),_vm._v(" "),_c('div',{staticClass:"row martop10"},[_c('h3',{staticClass:"title-24"},[_vm._v("2. Check-In Code")]),_vm._v(" "),_c('div',{staticClass:"text-24 font-bold"},[_c('p',[_vm._v("\n                This is a 10 digit number you provided to access the clubs.\n              ")])]),_vm._v(" "),_c('div',{staticClass:"text-24 martop10"},[_c('p',[_vm._v("\n                If you need assistance with your member number or check-in code, please visit your club.\n              ")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RqFH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-woff2.woff2";

/***/ }),

/***/ "V/CG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberValidationForm_vue__ = __webpack_require__("14Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422ad862_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberValidationForm_vue__ = __webpack_require__("ghm0");
function injectStyle (ssrContext) {
  __webpack_require__("GJ/R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-422ad862"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberValidationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422ad862_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberValidationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XB6r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xnkb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YZKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    isMemberValidated: false,
    memberValidationData: {
      memberIdentifier: '',
      birthDate: ''
    },
    memberData: {
      firstName: '',
      lastName: '',
      phone: '',
      memberNumber: '',
      address: {
        city: '',
        state: '',
        street: '',
        street2: '',
        zipcode: ''
      }
    },
    loginCredentials: {
      username: '',
      password: '',
      email: ''
    },
    securityQuestionCatalog: [],
    securityQuestionSelection: {
      id: '',
      answer: ''
    }
  },
  mutations: {
    setMemberValidationStatus: function setMemberValidationStatus(state, newStatus) {
      state.isMemberValidated = newStatus;
    },
    setMemberValidationData: function setMemberValidationData(state, data) {
      state.memberValidationData = data;
    },
    setMemberData: function setMemberData(state, memberData) {
      state.memberData = memberData;
    },
    setLoginCredentials: function setLoginCredentials(state, loginCredentials) {
      state.loginCredentials = loginCredentials;
    },
    setEmailAddress: function setEmailAddress(state, email) {
      state.loginCredentials.email = email;
    },
    setSecurityQuestionSelection: function setSecurityQuestionSelection(state, securityQuestionSelection) {
      state.securityQuestionSelection = securityQuestionSelection;
    },
    setSecurityQuestionCatalog: function setSecurityQuestionCatalog(state, securityQuestionCatalog) {
      state.securityQuestionCatalog = securityQuestionCatalog;
    }
  },
  getters: {
    getIsMemberValidated: function getIsMemberValidated(state) {
      return state.isMemberValidated;
    },

    getMemberValidationData: function getMemberValidationData(state) {
      return state.memberValidationData;
    },

    getMemberData: function getMemberData(state) {
      return state.memberData;
    },

    getLoginCredentials: function getLoginCredentials(state) {
      return state.loginCredentials;
    },

    getEmailAddress: function getEmailAddress(state) {
      return state.loginCredentials.email;
    },

    getSecurityQuestionCatalog: function getSecurityQuestionCatalog(state) {
      return state.securityQuestionCatalog;
    },

    getSecurityQuestionSelection: function getSecurityQuestionSelection(state) {
      return state.securityQuestionSelection;
    }
  }
}));

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_MemberValidation_vue__ = __webpack_require__("26Hx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_CreateProfile_vue__ = __webpack_require__("nA3w");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'MemberValidation',
    component: __WEBPACK_IMPORTED_MODULE_2__views_MemberValidation_vue__["a" /* default */]
  }, {
    path: '/CreateProfile',
    name: 'CreateProfile',
    component: __WEBPACK_IMPORTED_MODULE_3__views_CreateProfile_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      // If the user isn't coming from memberValidation, redirect it there
      if (from.name !== 'MemberValidation') {
        next({ name: 'MemberValidation' });
      } else {
        next();
      }
    }
  }, {
    path: '*',
    redirect: 'MemberValidation'
  }]
}));

/***/ }),

/***/ "Yw9J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLlC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'security-question-form',
  inject: ['$validator'],
  props: {
    securityQuestionCatalog: Array,
    validationScope: {
      type: String,
      default: 'securityQuestionValidation'
    },
    value: {
      type: Object,
      default: function _default() {
        return {
          id: '',
          question: '',
          answer: ''
        };
      }
    }
  },
  methods: {
    setSecurityQuestionId: function setSecurityQuestionId(id) {
      var valueCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.value);
      valueCopy.id = id;
      valueCopy.question = this.getSecurityQuestionText(id);
      this.$emit('input', valueCopy);
    },
    setSecurityAnswer: function setSecurityAnswer(answer) {
      var valueCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.value);
      valueCopy.answer = answer;
      this.$emit('input', valueCopy);
    },
    getSecurityQuestionText: function getSecurityQuestionText(id) {
      var questionText = this.securityQuestionCatalog.find(function (q) {
        if (q.id === id.toString()) {
          return q.question;
        } else {
          return '';
        }
      });

      questionText = (typeof questionText === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(questionText)) === 'object' ? questionText.question : questionText;

      return questionText;
    }
  }
});

/***/ }),

/***/ "bfMu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d45q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common__);



var Config = function Config() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Config);

  var envPath = __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForWebEnvironment();
  if (envPath === '') {
    envPath = 'www';
  }
  this.validateMemberUrl = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-validate-member-process/ValidateMember';
  this.validateUsernameUrl = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-validate-username-process/ValidateUsername';
  this.registerMemberUrl = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-user-registration-process/UserRegistration';

  // Links for button redirection
  this.memberLoginUrl = '/login.html';
  this.myProfileUrl = '/myaccount/profile.html';
  this.contactUsUrl = 'https://' + envPath + '.24hourfitness.com/contact_us';
};

var cfg = new Config();
/* harmony default export */ __webpack_exports__["a"] = (cfg);

/***/ }),

/***/ "e6NS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationHeader_vue__ = __webpack_require__("oRb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135349dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationHeader_vue__ = __webpack_require__("fRNp");
function injectStyle (ssrContext) {
  __webpack_require__("gakJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-135349dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrationHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135349dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrationHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fRNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-header"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{class:{ active: _vm.currentRouteString === tab.route }},[_c('a',[_c('span',{staticClass:"stepNumber"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('span',{staticClass:"stepName"},[_c('span',[_vm._v(_vm._s(tab.name))])]),_vm._v(" "),_c('span',[(index === 0)?_c('i',{staticClass:"fa fa-check fa-lg"}):_vm._e()])])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g1H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberNumberModal_vue__ = __webpack_require__("mrcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13575863_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberNumberModal_vue__ = __webpack_require__("RnEY");
function injectStyle (ssrContext) {
  __webpack_require__("wx/j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13575863"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberNumberModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13575863_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberNumberModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gakJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ghm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-form",attrs:{"id":"member-validation form"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberValidationData.memberIdentifier),expression:"memberValidationData.memberIdentifier"},{name:"validate",rawName:"v-validate",value:('required|max:15|min:1'),expression:"'required|max:15|min:1'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Member Number or Check-In Code","id":"memberIdentifier","name":"memberIdentifier","data-vv-scope":_vm.validationScope,"maxlength":"15"},domProps:{"value":(_vm.memberValidationData.memberIdentifier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberValidationData, "memberIdentifier", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"memberIdentifier"}},[_vm._v("Member Number or Check-In Code")]),_vm._v(" "),_c('span',{staticClass:"input-group-btn btn btn-view pull-right"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('openModal')}}},[_c('i',{staticClass:"fa fa-question-circle-o",attrs:{"aria-hidden":"true","title":"Where is my Member Number or Check-In Code?"}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.memberIdentifier')),expression:"errors.has(validationScope + '.memberIdentifier')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.memberIdentifier'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12"},[_c('div',{staticClass:"form-group materialized"},[_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:10|birthDateFormatValidator'),expression:"'required|max:10|birthDateFormatValidator'"}],staticClass:"form-control",attrs:{"type":"text","mask":"##/##/####","id":"birthDate","name":"birthDate","data-vv-scope":_vm.validationScope,"birthDate":_vm.memberValidationData.birthDate,"aria-invalid":_vm.errors.has(_vm.validationScope + '.birthDate'),"placeholder":"Birth Date (MM/DD/YYYY)"},model:{value:(_vm.memberValidationData.birthDate),callback:function ($$v) {_vm.$set(_vm.memberValidationData, "birthDate", $$v)},expression:"memberValidationData.birthDate"}}),_vm._v(" "),_c('label',{attrs:{"for":"birthDate"}},[_vm._v("Birth Date (MM/DD/YYYY)")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.birthDate')),expression:"errors.has(validationScope + '.birthDate')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.birthDate'))+"\n        ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group materialized col-xs-12 col-md5 buttons"},[_c('div',{staticClass:"col-xs-6"},[_c('button',{staticClass:"btn btn-default",on:{"click":_vm.goToLogin}},[_vm._v("Cancel")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.isFormSubmitted || _vm.errors.any(_vm.validationScope) || !_vm.isFormValidated},on:{"click":function($event){_vm.validateMember()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFormSubmitted),expression:"isFormSubmitted"}],staticClass:"fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"}),_vm._v("Continue")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gxZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasNumberValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasUpperAndLowerLetterValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasSpecialCharacterValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return birthDateFormatValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasUpperCaseValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasLowerCaseValidator; });
var hasNumberValidator = {
  getMessage: function getMessage(field) {
    return 'The password must contain at least one number. Please try again.';
  },
  validate: function validate(value) {
    return (/\d/.test(value)
    );
  }
};

var hasUpperAndLowerLetterValidator = {
  getMessage: function getMessage(field) {
    return 'The password must contain at least one uppercase and one lower case character. Please try again.';
  },
  validate: function validate(value) {
    return value.search(/[a-z]/) > -1 && value.search(/[A-Z]/) > -1;
  }
};

var hasUpperCaseValidator = {
  getMessage: function getMessage(field) {
    return 'The password must contain at least one uppercase character. Please try again.';
  },
  validate: function validate(value) {
    return value.search(/[A-Z]/) > -1;
  }
};

var hasLowerCaseValidator = {
  getMessage: function getMessage(field) {
    return 'The password must contain at least one lowercase character. Please try again.';
  },
  validate: function validate(value) {
    return value.search(/[a-z]/) > -1;
  }
};
/**
* Validate the field only contains letters, numbers and special characters allowed
*/
var hasSpecialCharacterValidator = {
  getMessage: function getMessage(field) {
    return "This field can contain only these special characters: ! # $ % * / ? I ^ { } ` ~ & ' + - = _. Please try again.";
  },
  validate: function validate(value) {
    return value.replace(/[a-zA-Z0-9`~!@#$%^&*_+-=?'{}]/gi, '').length <= 0;
  }
};

var birthDateFormatValidator = {
  getMessage: function getMessage(field) {
    return 'The value entered is not a valid date.';
  },
  validate: function validate(value) {
    if (value.length <= 7) {
      return false;
    } else {
      var month = value.substring(0, 2);
      if (+month > 12 || +month <= 0) {
        return false;
      }
      var days = value.substring(2, 4);
      if (+days > 31 || +days <= 0) {
        return false;
      }

      var year = value.substring(4, 8);
      if (+year >= 2100 || +year <= 0) {
        return false;
      }

      return true;
    }
  }
};



/***/ }),

/***/ "iR7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlreadyRegisteredModal_vue__ = __webpack_require__("E66g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18cf254e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlreadyRegisteredModal_vue__ = __webpack_require__("jlTA");
function injectStyle (ssrContext) {
  __webpack_require__("PpSn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18cf254e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlreadyRegisteredModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18cf254e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlreadyRegisteredModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jlTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",attrs:{"id":"already-registered-modal"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"title-header"},[_vm._v("\n            Your My24 Account was successfully created.\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link pull-right close-modal",on:{"click":function($event){_vm.$emit('closeModal')}}},[_c('i',{staticClass:"fa fa-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"text-24"},[_c('p',[_c('b',[_vm._v("Success!")]),_vm._v(" Your My24 Account was successfully created.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n              Your Fit:Perks® Account was not successfully created because the email address is already in use and cannot be used at this time.\n              Please contact us "),_c('a',{staticClass:"here-link",attrs:{"href":_vm.contactUsURL},on:{"click":function($event){_vm.redirectToContactUs()}}},[_vm._v("here")]),_vm._v(" or email us at\n              "),_c('a',{staticClass:"here-link",attrs:{"href":"mailto:CustomerServiceWT@24hourfit.com"}},[_vm._v("CustomerServiceWT@24hourfit.com")]),_vm._v(".\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jyl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-form",attrs:{"id":"user-information-form"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInformation.firstName),expression:"userInformation.firstName"}],staticClass:"form-control",attrs:{"id":"firstName","type":"text","placeholder":"First Name","name":"firstName","firstName":_vm.userInformation.firstName,"data-vv-scope":_vm.validationScope,"disabled":""},domProps:{"value":(_vm.userInformation.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInformation, "firstName", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.firstName')),expression:"errors.has(validationScope + '.firstName')"}],staticClass:"help form-errors"},[_vm._v("\n\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.firstName'))+"\n\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInformation.lastName),expression:"userInformation.lastName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Last Name","id":"lastName","name":"lastName","lastName":_vm.userInformation.lastName,"data-vv-scope":_vm.validationScope,"disabled":""},domProps:{"value":(_vm.userInformation.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInformation, "lastName", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.lastName')),expression:"errors.has(validationScope + '.lastName')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.lastName'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInformation.address.street),expression:"userInformation.address.street"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Address 1","id":"address-street","name":"address-street","address":_vm.userInformation.address.street,"data-vv-scope":_vm.validationScope},domProps:{"value":(_vm.userInformation.address.street)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInformation.address, "street", $event.target.value)},function (event) { return _vm.SetAddressInput('street', event.target.value); }]}}),_vm._v(" "),_c('label',{attrs:{"for":"address-street"}},[_vm._v("Address 1")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.address-street')),expression:"errors.has(validationScope + '.address-street')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.address-street'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInformation.address.street2),expression:"userInformation.address.street2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Address 2","id":"address-street2","name":"address-street2","address":_vm.userInformation.address.street2,"data-vv-scope":_vm.validationScope},domProps:{"value":(_vm.userInformation.address.street2)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInformation.address, "street2", $event.target.value)},function (event) { return _vm.SetAddressInput('street2', event.target.value); }]}}),_vm._v(" "),_c('label',{attrs:{"for":"address-street2"}},[_vm._v("Address 2")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.address-street2')),expression:"errors.has(validationScope + '.address-street2')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.address-street2'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInformation.address.city),expression:"userInformation.address.city"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"City","id":"address-city","name":"address-city","city":_vm.userInformation.address.city,"data-vv-scope":_vm.validationScope},domProps:{"value":(_vm.userInformation.address.city)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInformation.address, "city", $event.target.value)},function (event) { return _vm.SetAddressInput('city', event.target.value); }]}}),_vm._v(" "),_c('label',{attrs:{"for":"address-city"}},[_vm._v("City")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.address-city')),expression:"errors.has(validationScope + '.address-city')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.address-city'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-6 col-sm-3"},[_c('div',{staticClass:"form-group materialized"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"address-state","name":"address-state","data-vv-scope":_vm.validationScope,"placeholder":"Select"},on:{"input":function (event) { return _vm.SetAddressInput('state', event); }},model:{value:(_vm.userInformation.address.state),callback:function ($$v) {_vm.$set(_vm.userInformation.address, "state", $$v)},expression:"userInformation.address.state"}},_vm._l((_vm.states),function(state){return _c('el-option',{key:state,attrs:{"popper-class":"select-top","label":state,"value":state}})})),_vm._v(" "),_c('label',{attrs:{"for":"address-state"}},[_vm._v("State")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.address-state')),expression:"errors.has(validationScope + '.address-state')"}],staticClass:"help form-errors"},[_vm._v(_vm._s(_vm.errors.first(_vm.validationScope + '.address-state')))])],1)]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-6 col-sm-3"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInformation.address.zipCode),expression:"userInformation.address.zipCode"},{name:"validate",rawName:"v-validate",value:('required|numeric|digits:5'),expression:"'required|numeric|digits:5'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Zip Code","id":"address-zip","name":"address-zip","zipcode":_vm.userInformation.address.zipCode,"data-vv-scope":_vm.validationScope,"maxlength":"5"},domProps:{"value":(_vm.userInformation.address.zipCode)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInformation.address, "zipCode", $event.target.value)},function (event) { return _vm.SetZipcodeInput(event.target.value); }]}}),_vm._v(" "),_c('label',{attrs:{"for":"address-zip"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.address-zip')),expression:"errors.has(validationScope + '.address-zip')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.address-zip'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:10'),expression:"'required|min:10'"}],staticClass:"form-control",attrs:{"data-vv-name":"phone","id":"phone","mask":"(###) ###-####","phone":_vm.userInformation.phone,"data-vv-scope":_vm.validationScope,"placeholder":"Phone"},on:{"input":function (event) { return _vm.SetUserInfoInput('phone', event); }},model:{value:(_vm.userInformation.phone),callback:function ($$v) {_vm.$set(_vm.userInformation, "phone", $$v)},expression:"userInformation.phone"}}),_vm._v(" "),_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.phone')),expression:"errors.has(validationScope + '.phone')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.phone'))+"\n        ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kWJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading_vue__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ServiceContainer__ = __webpack_require__("tpCU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UserInformationForm__ = __webpack_require__("ul0A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LoginCredentialsForm__ = __webpack_require__("KVAj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SecurityQuestionForm__ = __webpack_require__("BOYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TermsOfUse__ = __webpack_require__("1xYc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AlreadyRegisteredModal__ = __webpack_require__("iR7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-profile',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading_vue__["a" /* default */],
    UserInformationForm: __WEBPACK_IMPORTED_MODULE_4__components_UserInformationForm__["a" /* default */],
    LoginCredentialsForm: __WEBPACK_IMPORTED_MODULE_5__components_LoginCredentialsForm__["a" /* default */],
    SecurityQuestionForm: __WEBPACK_IMPORTED_MODULE_6__components_SecurityQuestionForm__["a" /* default */],
    TermsOfUse: __WEBPACK_IMPORTED_MODULE_7__components_TermsOfUse__["a" /* default */],
    AlreadyRegisteredModal: __WEBPACK_IMPORTED_MODULE_8__components_AlreadyRegisteredModal__["a" /* default */]
  },
  data: function data() {
    return {
      isModalOpen: false,
      showSpinner: false,
      reEnableSubmitButton: false,
      memberValidationData: {
        memberIdentifier: '',
        birthDate: ''
      },
      memberData: {
        firstName: '',
        lastName: '',
        phone: '',
        address: {
          city: '',
          state: '',
          street: '',
          street2: '',
          zipCode: ''
        }
      },
      userCredentials: {
        username: '',
        email: '',
        password: ''
      },
      securityQuestionCatalog: [],
      selectedSecurityQuestion: {
        id: '',
        question: '',
        answer: ''
      },
      termsOfUse: {
        subscribeToFitperks: true,
        acceptTerms: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Validate UserInformation form upon entering
    setTimeout(function () {
      _this.validateUserInformationOnLoad();
    }, 500);

    // Redirect user to memberValidation if status is set to false
    if (!this.getIsMemberValidated) {
      this.$router.push({ path: '/' });
    }

    this.showSpinner = true;
    this.showSpinner = false;
    this.memberData = this.getMemberData;
    this.userCredentials.email = this.getEmailAddress;
    this.memberData.address.zipCode = this.memberData.address.zipCode.substr(0, 5);
    this.securityQuestionCatalog = this.getSecurityQuestionCatalog;
  },

  methods: {
    setMemberData: function setMemberData(data) {
      this.memberData = data;
      this.memberData.firstName = __WEBPACK_IMPORTED_MODULE_9_my_account_common__["StringUtils"].initCaps(this.memberData.firstName);
      this.memberData.lastName = __WEBPACK_IMPORTED_MODULE_9_my_account_common__["StringUtils"].initCaps(this.memberData.lastName);
      this.memberData.address.city = __WEBPACK_IMPORTED_MODULE_9_my_account_common__["StringUtils"].initCaps(this.memberData.address.city);
      this.memberData.address.street = __WEBPACK_IMPORTED_MODULE_9_my_account_common__["StringUtils"].initCaps(this.memberData.address.street);
      this.memberData.address.street2 = __WEBPACK_IMPORTED_MODULE_9_my_account_common__["StringUtils"].initCaps(this.memberData.address.street2);
    },
    setUserCredentials: function setUserCredentials(data) {
      this.userCredentials = data;
    },
    setSelectedQuestion: function setSelectedQuestion(data) {
      this.selectedSecurityQuestion = data;
    },
    setTermsOfUseData: function setTermsOfUseData(data) {
      this.termsOfUse = data;
    },


    // Validate fields when entering page
    validateUserInformationOnLoad: function validateUserInformationOnLoad() {
      this.$validator.validate('userInformation.address-street');
      this.$validator.validate('userInformation.address-city');
      this.$validator.validate('userInformation.address-state');
      this.$validator.validate('userInformation.address-zip');
      this.$validator.validate('userInformation.phone');
      if (this.userCredentials.email.length > 0) {
        this.$validator.validate('loginCredentialsValidation.email');
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.reEnableSubmitButton = false;
      __WEBPACK_IMPORTED_MODULE_3__services_ServiceContainer__["a" /* createProfileService */].registerMember(this.userDataObject).then(function (success) {
        if (success.data.securityToken) {
          _this2.logUser(success.data.securityToken);
          if (_this2.termsOfUse.subscribeToFitperks && success.data.ctRegistration === 'false') {
            _this2.openModal();
          } else {
            _this2.goToMyProfile();
          }
        }
      }).catch(function (error) {
        _this2.reEnableSubmitButton = true;
        if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
          _this2.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
            theme: 'primary',
            position: 'bottom-center',
            duration: 10000
          });
        } else {
          _this2.$toasted.show('There was an unexpected error when trying to register', {
            theme: 'primary',
            position: 'bottom-center',
            duration: 5000
          });
        }
      });
    },
    logUser: function logUser(securityToken) {
      var Cookies = __webpack_require__("lbHh");
      Cookies.set('securityToken', securityToken);
    },
    goToMyProfile: function goToMyProfile() {
      window.open(__WEBPACK_IMPORTED_MODULE_3__services_ServiceContainer__["a" /* createProfileService */].getMyProfileUrl(), '_self');
    },
    openModal: function openModal() {
      this.isModalOpen = true;
    },
    closeModal: function closeModal() {
      this.isModalOpen = false;
      this.goToMyProfile();
    },
    cancelRegistration: function cancelRegistration() {
      if (confirm('This action will cancel your My24 Account Registration.  Are you sure you want to continue?')) {
        // Clearing store data
        this.$store.commit('setMemberValidationData', {});
        this.$store.commit('setMemberData', {});
        this.$store.commit('setSecurityQuestionCatalog', {});
        this.$store.commit('setMemberValidationStatus', false);

        this.$router.push({ path: '/' });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(['getIsMemberValidated', 'getMemberValidationData', 'getMemberData', 'getSecurityQuestionCatalog', 'getEmailAddress']), {
    areAllFormsValid: function areAllFormsValid() {
      var _this3 = this;

      // Check validity of User Information component
      if (this.fields.$userInformation || this.fields.$securityQuestionValidation || this.fields.$loginCredentialsValidation) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields.$userInformation).every(function (key) {
          return _this3.fields.$userInformation[key].valid;
        }) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields.$securityQuestionValidation).every(function (key) {
          return _this3.fields.$securityQuestionValidation[key].valid;
        }) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields.$loginCredentialsValidation).every(function (key) {
          return _this3.fields.$loginCredentialsValidation[key].valid;
        });
      } else {
        return false;
      }
    },
    userDataObject: function userDataObject() {
      return {
        memberNumber: this.getMemberData.memberNumber,
        dateOfBirth: this.getMemberValidationData.birthDate,
        city: this.memberData.address.city,
        street: this.memberData.address.street,
        street2: this.memberData.address.street2,
        state: this.memberData.address.state,
        zipcode: this.memberData.address.zipCode,
        phoneNumber: this.memberData.phone,
        username: this.userCredentials.username,
        email: this.userCredentials.email,
        password: this.userCredentials.password,
        securityAnswer: this.selectedSecurityQuestion.answer,
        securityQuestion: this.selectedSecurityQuestion.question,
        securityQuestionId: this.selectedSecurityQuestion.id,
        fitPerksAgreements: this.termsOfUse.subscribeToFitperks.toString()
      };
    }
  })
});

/***/ }),

/***/ "lIB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dictionary = {
  en: {
    messages: {
      required: function required() {
        return 'This is a required field.';
      },
      email: function email() {
        return 'The email field must be a valid email.';
      }
    },
    custom: {
      'nameOnCard': {
        regex: function regex() {
          return 'The name on card can contain only alphabetical letters and these characters: ~ ^ & * ( ) - [ ] \\.';
        },
        alpha_spaces: function alpha_spaces() {
          return 'No numbers allowed for this field.';
        }
      },
      'accountConfirm': {
        confirmed: function confirmed() {
          return 'The account numbers entered do not match. Please try again.';
        }
      },
      'routingConfirm': {
        confirmed: function confirmed() {
          return 'The routing numbers entered do not match. Please try again.';
        }
      },
      'routingNumber': {
        max: function max() {
          return 'The routing number must be 9 digits. Please try again.';
        },
        min: function min() {
          return 'The routing number must be 9 digits. Please try again.';
        }
      },
      'address-zip': {
        digits: function digits() {
          return 'The Zipcode must be 5 digits.';
        },
        numeric: function numeric() {
          return 'The Zipcode can only contain numeric characters.';
        }
      },
      'mobile-phone': {
        min: function min() {
          return 'The phone number entered is an invalid format. Please try again.';
        }
      },
      'password': {
        min: function min() {
          return 'The password fields entered are not in a valid format. Passwords must be between 8-14 characters long and are case sensitive. Please try again.';
        },
        max: function max() {
          return 'The password fields entered are not in a valid format. Passwords must be between 8-14 characters long and are case sensitive. Please try again.';
        }
      },
      'username': {
        min: function min() {
          return 'The username you enter must be at least 6 characters long. Please re-enter your username again.';
        },
        max: function max() {
          return 'The username you enter must be less than 60 characters long. Please re-enter your username again.';
        },
        hasSpecialCharacterValidator: function hasSpecialCharacterValidator() {
          return 'The username can contain only these special characters: ! # $ % * / ? I ^ { } ` ~ & \' + - = _ .- @ - .. Please re-enter your username again.';
        }
      },
      'confirmPassword': {
        confirmed: function confirmed() {
          return 'The passwords do not match. Please try again.';
        },
        min: function min() {
          return 'The confirm password field must be at least 8 characters.';
        },
        max: function max() {
          return 'The confirm password field may not be greater than 14 characters.';
        }
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dictionary);

/***/ }),

/***/ "mrcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'member-number-modal',
  mounted: function mounted() {
    document.addEventListener('keyup', this.listener);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keyup', this.listener);
  },
  data: function data() {
    var _this = this;

    return {
      listener: function listener(evt) {
        if (evt.keyCode === 27) {
          _this.$emit('closeModal');
        }
      }
    };
  }
});

/***/ }),

/***/ "nA3w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProfile_vue__ = __webpack_require__("kWJ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cc486e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProfile_vue__ = __webpack_require__("IAAN");
function injectStyle (ssrContext) {
  __webpack_require__("wG6F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cc486e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oRb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'registration-header',
  data: function data() {
    return {
      tabs: [{ name: 'Validate Membership', route: 'MemberValidation' }, { name: 'Create Your Login', route: 'CreateProfile' }],
      currentRouteName: ''
    };
  },

  computed: {
    currentRouteString: function currentRouteString() {
      return this.$route.name.replace(/Mobile+/i, '');
    }
  }
});

/***/ }),

/***/ "p1eK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showing)?_c('div',{class:{'white-overlay': _vm.overlay}},[_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"pulled-left",staticStyle:{"padding":"10px 20px"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-layer spinner-layer--blue"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--red"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--yellow"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--green"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qTov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__ = __webpack_require__("gxZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ServiceContainer__ = __webpack_require__("tpCU");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('hasNumberValidator', __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["c" /* hasNumberValidator */]);
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('hasUpperAndLowerLetterValidator', __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["e" /* hasUpperAndLowerLetterValidator */]);
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('hasSpecialCharacterValidator', __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["d" /* hasSpecialCharacterValidator */]);
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('hasUpperCaseValidator', __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["f" /* hasUpperCaseValidator */]);
__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('hasLowerCaseValidator', __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["b" /* hasLowerCaseValidator */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-credentials-form',
  inject: ['$validator'],
  props: {
    validationScope: {
      type: String,
      default: 'loginCredentialsValidation'
    },
    value: {
      type: Object,
      default: function _default() {
        return {
          username: '',
          email: '',
          password: '',
          confirmPassword: ''
        };
      }
    }
  },
  data: function data() {
    return {
      uName: ''
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('verify-username', {
      getMessage: function getMessage(field) {
        return 'The username selected is already in use.  Please enter a new one.';
      },
      validate: function validate(value) {
        return __WEBPACK_IMPORTED_MODULE_4__services_ServiceContainer__["a" /* createProfileService */].validateUsername({
          params: {
            userName: value
          }
        }).then(function (response) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({ valid: response.data.success });
        }).catch(function (error) {
          console.log(error);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject({ valid: false });
        });
      }
    });
  },

  methods: {
    setValue: function setValue(key, value) {
      var valueCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.value);
      valueCopy[key] = value;
      this.$emit('input', valueCopy);
    },
    togglePassword: function togglePassword(el) {
      var newType = el.getAttribute('type') === 'password' ? 'text' : 'password';
      el.setAttribute('type', newType);
      el.focus();
    },

    validateHasANumber: __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["c" /* hasNumberValidator */].validate,
    validateHasUpperAndLowerLetter: __WEBPACK_IMPORTED_MODULE_3__services_custom_validators__["e" /* hasUpperAndLowerLetterValidator */].validate,
    validateLength: function validateLength(value) {
      return value.length >= 8 && value.length <= 14;
    }
  },
  watch: {
    uName: function uName(val) {
      this.value.username = val;
    }
  }
});

/***/ }),

/***/ "roS0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPdF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-woff.woff";

/***/ }),

/***/ "tpCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axios */
/* unused harmony export authService */
/* unused harmony export sessionCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return memberValidationService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createProfileService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MemberValidationService__ = __webpack_require__("xjSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateProfileService__ = __webpack_require__("AUbG");




var authService = new __WEBPACK_IMPORTED_MODULE_0_my_account_common__["AuthService"]();
var sessionCache = new __WEBPACK_IMPORTED_MODULE_0_my_account_common__["SessionCache"](authService, { key: 'my-registration' });
var axiosCache = Object(__WEBPACK_IMPORTED_MODULE_0_my_account_common__["cachiosConfigure"])(authService, { ttl: 5, sessionCache: sessionCache }, __WEBPACK_IMPORTED_MODULE_0_my_account_common__["cachiosFactory"]);
var memberValidationService = new __WEBPACK_IMPORTED_MODULE_1__MemberValidationService__["a" /* MemberValidationService */](axiosCache);
var createProfileService = new __WEBPACK_IMPORTED_MODULE_2__CreateProfileService__["a" /* CreateProfileService */](axiosCache);



/***/ }),

/***/ "u6Tb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/member_number.png";

/***/ }),

/***/ "uk6X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-ttf.ttf";

/***/ }),

/***/ "ul0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInformationForm_vue__ = __webpack_require__("0ox+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41503a52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInformationForm_vue__ = __webpack_require__("jyl5");
function injectStyle (ssrContext) {
  __webpack_require__("Xnkb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInformationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41503a52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInformationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vTfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24",attrs:{"id":"member-validation-container"}},[_c('loading',{attrs:{"show":_vm.showSpinner,"label":"Loading...","overlay":"true"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"container member-validation-container"},[_vm._m(0,false,false),_vm._v(" "),(_vm.memberValidationError.length > 0)?_c('div',{staticClass:"row member-validation-section"},[_c('section',{staticClass:"col-sm-12 member-validation-error alert alert-danger",attrs:{"role":"alert"}},[_c('div',[_c('a',{staticClass:"close",attrs:{"aria-label":"close","title":"close"},on:{"click":function($event){_vm.memberValidationError = ''}}},[_vm._v("\n              ×\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.memberValidationError))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-xs-12"},[_c('member-validation-form',{attrs:{"memberLoginUrl":_vm.memberLoginUrl,"reEnableSubmitButton":_vm.reEnableSubmitButton},on:{"submitData":_vm.validateMember,"openModal":_vm.openModal}})],1),_vm._v(" "),_vm._m(1,false,false)])]),_vm._v(" "),(_vm.isModalOpen)?_c('member-number-modal',{on:{"closeModal":_vm.closeModal}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row member-validation-section"},[_c('section',{staticClass:"col-sm-12 member-validation-desc-header"},[_c('h2',{staticClass:"title-24"},[_vm._v("Create new account")]),_vm._v(" "),_c('p',[_vm._v("Setup online access to your membership account in two easy steps.")]),_vm._v(" "),_c('h3',{staticClass:"title-24"},[_vm._v("1. Validate Membership")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-xs-12 registration-form-image"},[_c('div',{staticClass:"card-img-container pull-right"},[_c('img',{staticClass:"img img-responsive",attrs:{"src":__webpack_require__("Chc6"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wG6F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wcAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-of-use',
  props: {
    reEnableSubmitButton: false,
    areAllFormsValid: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: function _default() {
        return {
          subscribeToFitperks: false,
          acceptTerms: false
        };
      }
    }
  },
  data: function data() {
    return {
      isSubmitting: false,
      termsOfUseURL: 'https://24hourfitness.com/company/policies/privacy/privacy_policy.html',
      fitPerksTermsURL: 'https://www.24hourfitness.com/fitperks/#terms',
      privacyPolicyURL: 'https://24hourfitness.com/company/policies/privacy/privacy_policy.html'
    };
  },

  methods: {
    updateValue: function updateValue(key, value) {
      var valueCopy = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.value);
      valueCopy[key] = value;
      this.$emit('input', valueCopy);
    },
    submitForm: function submitForm() {
      this.isSubmitting = true;
      this.$emit('submitForm');
    },
    cancelRegistration: function cancelRegistration() {
      this.$emit('cancelRegistration');
    }
  },
  watch: {
    reEnableSubmitButton: function reEnableSubmitButton(value) {
      if (value) {
        this.isSubmitting = false;
      }
    }
  }
});

/***/ }),

/***/ "wpyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"terms-of-use-container"}},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-8 materialized"},[_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"md-checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"subscribeToFitperks","id":"subscribeToFitperks"},domProps:{"checked":_vm.value.subscribeToFitperks},on:{"click":function (event) { return _vm.updateValue('subscribeToFitperks', event.target.checked); }}}),_vm._v(" "),_c('label',{attrs:{"for":"subscribeToFitperks"}},[_vm._v("\n                  I would like to sign up for the Fit:Perks® program.\n                  "),_c('a',{attrs:{"href":_vm.fitPerksTermsURL,"target":"_blank"}},[_c('span',{staticClass:"checkbox-link"},[_vm._v(" Learn more about Fit:Perks®  ")])])])])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"md-checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"acceptTerms","id":"acceptTerms"},domProps:{"checked":_vm.value.acceptTerms},on:{"click":function (event) { return _vm.updateValue('acceptTerms', event.target.checked); }}}),_vm._v(" "),_c('label',{attrs:{"for":"acceptTerms"}},[_vm._v("\n                  I agree to the 24hourfitness.com\n                  "),_c('a',{attrs:{"href":_vm.termsOfUseURL,"target":"_blank"}},[_c('span',{staticClass:"checkbox-link"},[_vm._v(" Terms of Use ")])])])])])])]),_vm._v(" "),_c('p',[_vm._v("We will automatically enroll you to receive news and offers from 24 Hour Fitness upon confirmation of your account")]),_vm._v(" "),_c('p',[_vm._v("\n          You can change this setting at any time by clicking on the Change Preferences tab. (See also\n          "),_c('a',{attrs:{"href":_vm.privacyPolicyURL,"target":"_blank"}},[_c('span',{staticClass:"checkbox-link"},[_vm._v("Privacy Policy")])]),_vm._v(")\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3 col-sm-offset-1 buttons-container"},[_c('div',{staticClass:"form-group materialized"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.value.acceptTerms || _vm.isSubmitting || !_vm.areAllFormsValid},on:{"click":function($event){_vm.submitForm()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSubmitting),expression:"isSubmitting"}],staticClass:"fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"}),_vm._v("\n            Submit\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.$emit('cancelRegistration')}}},[_vm._v("Cancel")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12"},[_c('h2',{staticClass:"title-24"},[_vm._v("Accept Terms of Use")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wx/j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RegistrationHeader_vue__ = __webpack_require__("e6NS");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TitleContainer: __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__["TitleContainer"],
    RegistrationHeader: __WEBPACK_IMPORTED_MODULE_1__components_RegistrationHeader_vue__["a" /* default */]
  },
  name: 'app'
});

/***/ }),

/***/ "xjSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemberValidationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__ = __webpack_require__("d45q");




var MemberValidationService = function () {
  function MemberValidationService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MemberValidationService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MemberValidationService, [{
    key: 'validateMember',
    value: function validateMember(config) {
      return this.axios.get(__WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].validateMemberUrl, config);
    }
  }, {
    key: 'getLoginUrl',
    value: function getLoginUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__configuration_PropertiesConfiguration__["a" /* default */].memberLoginUrl;
    }
  }]);

  return MemberValidationService;
}();

/***/ }),

/***/ "zreh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"security-question-form"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"security-question-section materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"placeholder":"Select a Question","id":"security-question","name":"security-question","value":_vm.value.id,"data-vv-name":"security-question","data-vv-scope":_vm.validationScope,"aria-invalid":"errors.has(validationScope + '.security-question')"},on:{"input":function (event) { return _vm.setSecurityQuestionId(event); }}},_vm._l((_vm.securityQuestionCatalog),function(securityQuestion){return _c('el-option',{key:securityQuestion.id,attrs:{"popper-class":"select-top","label":securityQuestion.question,"value":securityQuestion.id}})})),_vm._v(" "),_c('label',{attrs:{"for":"security-question"}},[_vm._v("Security Question")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.security-question')),expression:"errors.has(validationScope + '.security-question')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.security-question'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"security-question-section materialized col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"security-answer",staticClass:"form-control",attrs:{"type":"text","id":"security-answer","name":"security-answer","data-vv-name":"security-answer","data-vv-scope":_vm.validationScope,"aria-invalid":"errors.has(validationScope + '.security-answer')","placeholder":"Answer"},domProps:{"value":_vm.value.answer},on:{"input":function (event) { return _vm.setSecurityAnswer(event.target.value); }}}),_vm._v(" "),_c('label',{attrs:{"for":"security-answer"}},[_vm._v("Answer")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.validationScope + '.security-answer')),expression:"errors.has(validationScope + '.security-answer')"}],staticClass:"help form-errors"},[_vm._v("\n          "+_vm._s(_vm.errors.first(_vm.validationScope + '.security-answer'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.js